var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "TickerPopover",
    {
      attrs: {
        title: _vm.detail ? _vm.$t("Schedule details") : _vm.$t("Schedules"),
        "show-back": !!_vm.detail,
        width: _vm.detail ? 380 : 244,
        left: _vm.left,
        "arrow-left": _vm.arrowLeft,
      },
      on: {
        back: function ($event) {
          _vm.detail = null
        },
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _vm.detail
        ? _c(
            "div",
            { staticClass: "schedule-popover__detail" },
            [_c("ScheduleDetail")],
            1
          )
        : _c(
            "div",
            { staticClass: "schedule-popover__list" },
            _vm._l(_vm.schedules, function (schedule, index) {
              return _c("ScheduleRow", {
                key: "schedule_" + index,
                staticClass: "schedule-popover__row",
                attrs: { schedule: schedule, compact: "" },
                on: {
                  goToDetails: function ($event) {
                    return _vm.openDetail(schedule)
                  },
                },
              })
            }),
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }